import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=5c699823&scoped=true&"
import script from "./QA.vue?vue&type=script&lang=js&"
export * from "./QA.vue?vue&type=script&lang=js&"
import style0 from "./QA.vue?vue&type=style&index=0&id=5c699823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c699823",
  null
  
)

export default component.exports